/// Entry point — Sprint 4 Phase 1 Step 1.4 scaffolding.
/// Reference: research evidence-srs.md Evidence #13, #15, #16.

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Vue3Toastify, { type ToastContainerOptions } from 'vue3-toastify'

import App from './App.vue'
import { router } from './core/router'
import { i18n } from './core/i18n'
import { registerGlobalErrorReporting, reportClientError } from './core/observability/error-reporter'
import { installChunkReloadHandler } from './composables/useChunkReload'
import { TOAST_AUTO_CLOSE_MS } from './shared/config/toast'

import 'vue3-toastify/dist/index.css'
import './style.css'

const app = createApp(App)

// OBS error-monitoring: bắt lỗi runtime Web → báo server (best-effort, fail-silent).
app.config.errorHandler = (err, _instance, info) => {
  reportClientError(err, { context: { vueInfo: info } })
  // giữ log console cho dev; không nuốt lỗi khỏi devtools
  console.error(err)
}
registerGlobalErrorReporting()

// Stale-chunk sau deploy: phát hiện lazy chunk 404 → hiện modal yêu cầu reload.
installChunkReloadHandler(router)

app.use(createPinia())
app.use(router)
app.use(i18n)
// Global toast feedback for mutations (success/error) — see CLAUDE.WEB.md.
app.use(Vue3Toastify, {
  // Thời gian giữ toast: hằng số dùng chung, KHÔNG viết số ở đây (xem shared/config/toast.ts).
  autoClose: TOAST_AUTO_CLOSE_MS,
  position: 'top-right',
  theme: 'light',
} as ToastContainerOptions)

app.mount('#app')
